export default __webpack_public_path__ + "static/section-divider-dcd1038ff257ac33ad1e2a0512a61b76.svg";